import { getSpellSlotProfile } from '../../../shared/rules/spellSlots.mjs';

/** The slots a level 1 Reaction spell can use, lowest first; a Pact slot follows the Spellcasting slots. */
export const reactionSlotOptions = (form) => {
  const { spellcasting, pactMagic } = getSpellSlotProfile(form);
  return [
    ...Object.entries(spellcasting.remainingByLevel).filter(([, left]) => left > 0)
      .map(([level, left]) => ({ pool: 'spellcasting', slotLevel: Number(level), label: `Level ${level} slot (${left} left)` })),
    ...(pactMagic.remaining > 0 ? [{ pool: 'pactMagic', slotLevel: pactMagic.slotLevel, label: `Pact slot, level ${pactMagic.slotLevel} (${pactMagic.remaining} left)` }] : []),
  ];
};
